import { createSelector } from 'reselect';
import commonSelector, { selectedCustomerIdSelector } from '@store/common/selectors';
import metricsChartContainerSelector from '@store/metricsChartContainer/selectors';
import comparisonSelector from '@store/summaryContainer/comparison/selectors';
import summaryStoreSelector from '@store/summaryContainer/selectors';
import viewerSessionsSelector from '@store/viewerSessions/selectors';
import { selectedAiAlertSelector } from '@store/trends/aiAlerts/selectors';
import { summaryWidgetsSelector } from '@store/summaryWidgets/selector';
import { activeDashboardSelector } from '@store/tempDashboard/selectors';
import alertStateSelector from '../alerts/selectors';
import { birdChartSharedSelector as viewerDrillDownBirdChartSelector } from '../birdChart/selectors';
import { trendsBaseSharingSelector } from '../base/selectors';
import { SUMMARY_PANEL_TYPE } from '@components/top-widget-panel/constants';

export const savingSelector = createSelector(
  commonSelector as any,
  comparisonSelector,
  summaryWidgetsSelector,
  metricsChartContainerSelector,
  viewerDrillDownBirdChartSelector,
  viewerSessionsSelector,
  summaryStoreSelector,
  selectedCustomerIdSelector,
  alertStateSelector,
  selectedAiAlertSelector,
  trendsBaseSharingSelector,
  activeDashboardSelector,
  (
    commonStore,
    comparisonStore,
    summaryWidgets,
    metricsChartContainerStore,
    viewerDrillDownBirdChart,
    viewerSessionsStore,
    summaryContainer,
    selectedCustomerId,
    alertState,
    selectedAiAlert,
    trendsBase,
    activeDashboard,
  ) => {
    const dashboard = 'trends';
    const { interval, appliedFilters, filterColor, tzOffset, collapseStatus, dod, layout } =
      commonStore;
    const { interval: comparisonInterval } = comparisonStore;
    const { selectedMetrics, dataType } = viewerSessionsStore.trends;
    const drilldownData = summaryContainer.drilldown;
    const start = interval.from;
    const end = interval.to;
    const title = `Trends ${start} ${end}`;

    const { usecaseKey, widgetMeta } = activeDashboard || {};
    return {
      title,
      dashboard,
      start,
      end,
      usecaseKey,
      widgetMeta,
      state: {
        common: {
          appliedFilters,
          interval,
          filterColor,
          tzOffset,
          selectedCustomerId,
          collapseStatus,
          dod,
          layout,
        },
        comparison: {
          interval: comparisonInterval,
        },
        summaryWidgets: {
          type: summaryWidgets.type || SUMMARY_PANEL_TYPE.SPI,
          widgets: summaryWidgets.widgets,
        },
        // new trends layout
        metricsChartContainer: {
          metric: metricsChartContainerStore.metric,
          metrics: metricsChartContainerStore.metrics,
        },
        viewerDrillDownBirdChart,
        summary: {
          drilldownData,
        },
        viewerSessionsTable: {
          selectedMetrics,
          dataType,
        },
        selectedAiAlert,
        'module:trends': {
          alerts: alertState,
          selectedAiAlert,
          base: trendsBase,
        },
      },
    };
  },
);
